// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"8b2c0c7e","228":"f04b8aac","453":"e2360db7","461":"50366599","550":"955752c7","586":"a699c502","653":"816e9144","667":"75af5bce","832":"e5be43e6","977":"b340e4fa","980":"bbaf7eb7"}[chunkId] + ".chunk.js";
};